module.exports = __webpack_public_path__ + "static/img/price.469e13f9.png";